import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import EditPaymentButton from 'src/components/Control/Buttons/EditPaymentButton';
import RetryPaymentButton from 'src/components/Control/Buttons/RetryPaymentButton';
import RefundPaymentButton from 'src/components/Control/Buttons/RefundPaymentButton';
import CancelPaymentButton from 'src/components/Control/Buttons/CancelPaymentButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import ExportPaymentButton from 'src/components/Control/Buttons/ExportPaymentButton';
import DownloadPaymentButton from 'src/components/Control/Buttons/DownloadPaymentButton';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import SelectAllMenubutton from '../../Control/Buttons/SelectAllMenuButton';

const useStyles = makeStyles((theme: Theme) => ({
  actionMenuContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    borderTop: 'none',
    border: '1px solid #eee',
    padding: theme.spacing(1),
    backgroundColor: '#f8f8f8',
  },
}));

const PaymentInvoiceToolbar = () => {
  const classes = useStyles();

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );

  const getPaymentId = () => {
    if (!selections.length) return 0;
    return selections[0];
  };

  return (
    <div className={`${classes.actionMenuContainer}`}>
      <EditPaymentButton
        disabled={!selections.length} />
      <RefundPaymentButton
        disabled={selections.length !== 1}
        paymentId={getPaymentId()} />
      <RetryPaymentButton
        disabled={!selections.length} />
      <CancelPaymentButton
        disabled={!selections.length} />
      <ConfigureColumnsButton
        entity={ENTITIES.payments} />
      <UnselectAllMenubutton
        entity={ENTITIES.payments}
        disabled={!selections.length} />
      <SelectAllMenubutton
        entity={ENTITIES.payments} />
      <ExportPaymentButton
        disabled={!selections.length} />
      <DownloadPaymentButton />
    </div>
  );
};

export default PaymentInvoiceToolbar;
